const ormServicesData = [
  {
    title: "Monitoring",
    description:
      "Continuously track brand mentions, reviews, forums, and sentiment across channels with alerts.",
    bullets: ["Reviews", "Mentions", "Alerts", "Sentiment"],
    minHeight: 400,
  },
  {
    title: "Response",
    description:
      "Operational playbooks for timely, empathetic responses with SLAs and escalation procedures.",
    bullets: ["Templates", "Escalation", "SLAs", "Tracking"],
    minHeight: 400,
  },
  {
    title: "Content",
    description:
      "Publish positive content and manage PR to strengthen reputation and outrank negative narratives.",
    bullets: ["PR", "Content", "Partners", "Outreach"],
    minHeight: 400,
  },
  {
    title: "Recovery",
    description:
      "Structured crisis response to mitigate negative content, including takedowns and corrective SEO.",
    bullets: ["Takedown", "Legal", "SEO", "Campaigns"],
    minHeight: 400,
  },
  {
    title: "Analytics",
    description:
      "Dashboards for sentiment, share of voice, competitor tracking, and ROI of ORM programs.",
    bullets: ["Dashboards", "KPIs", "SOV", "Reports"],
    minHeight: 400,
  },
  {
    title: "Governance",
    description:
      "Clear governance with policies, training, and approvals to ensure consistent brand responses.",
    bullets: ["Policies", "Training", "Compliance", "Audits"],
    minHeight: 400,
  },
  {
    title: "Brand Guidelines",
    description:
      "Define messaging, tone, and response frameworks with examples for different scenarios.",
    bullets: ["Tone", "Do/Don't", "Playbooks", "Escalation"],
    minHeight: 400,
  },
  {
    title: "Listings & Profiles",
    description:
      "Audit and optimize business profiles and directories for accuracy, visibility, and conversions.",
    bullets: ["NAP", "Photos", "UTMs", "Links"],
    minHeight: 400,
  },
  {
    title: "Proactive PR",
    description:
      "Proactively publish case studies, stories, and partnerships to shape brand perception.",
    bullets: ["Stories", "Case Studies", "Partners", "Coverage"],
    minHeight: 400,
  },
];

export default ormServicesData;
